import React from 'react';

// @ts-ignore
import styles from './Header.module.scss?module';
import { Col, Container, Row } from 'react-bootstrap';
import Link from '../../../Abstracts/Link/Link';
import {
  faHouse,
  faBagShopping,
  faHeart,
} from '@fortawesome/pro-solid-svg-icons';
import NavigationButton from '../Components/NavigationButton/NavigationButton';
import { useUser } from '../../../Context/UserContext';
import { getRequest } from '../../../Helper/ApiClient';
import { formatCurrencyEur } from '../../../Helper/formatter';
import {useNcw} from "../Context/NcwContext";

export default function Header() {
  const { user } = useUser();
  const { basketInfo } = useNcw();

  return (
    <>
      <div style={{ height: '56px', opacity: '0' }}>Save space header</div>
      <Container
        fluid
        className={styles.Header}
        style={{
          position: 'fixed',
          zIndex: 10,
          top: 0,
          left: 0,
          width: '100%',
          // opacity: '.5',
        }}
      >
        <Row
          style={{
            maxWidth: '100vw',
            overflowX: 'hidden',
            minHeight: '56px',
            maxHeight: '56px',
          }}
        >
          <Col xs={3} className="align-items-center d-flex">
            <Link
              to={'/newcomer-week/home'}
              inheritColor
              className={`${styles.Nav} p-0`}
            >
              <NavigationButton icon={faHouse} />
            </Link>
          </Col>
          <Col
            xs={6}
            className="d-flex align-items-center justify-content-center overflow-hidden"
            style={{ maxHeight: '56px' }}
          >
            <Link
              to={'/newcomer-week/home'}
              inheritColor
              className={`${styles.Nav} p-0`}
            >
              <span
                style={{
                  fontFamily: 'newcomer-week, Arial, sans-serif',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              className="text-32">
                Newcomer Week
              </span>
            </Link>
          </Col>
          <Col
            xs={3}
            className={
              'text-end d-flex gap-2 align-items-center justify-content-end'
            }
          >
            {user && (
              <>
                {/*<Link
                  to={'/newcomer-week/favorites'}
                  inheritColor
                  // className={styles.Nav}
                >
                  <NavigationButton icon={faHeart} />
                </Link>*/}
                <Link
                  className="d-flex align-items-center"
                  to={'/newcomer-week/basket'}
                  inheritColor
                  // className={styles.Nav}
                >
                  <NavigationButton
                    icon={faBagShopping}
                    badge={
                      basketInfo &&
                      basketInfo.total_quantity > 0
                        ? basketInfo.total_quantity.toString()
                        : undefined
                    }
                  />
                  &nbsp;
                  {basketInfo &&
                    basketInfo.total_price > 0 && (
                      <small className="fw-bold fst-italic d-none d-sm-none d-md-block">
                        {formatCurrencyEur(
                          basketInfo.total_price
                        )}
                      </small>
                    )}
                </Link>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}
